import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import type { JiraHomeRouteResourceData } from '@jira/global-pages__home/src/common/types/route-resource.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { expVal } from '@atlassian/jira-feature-experiments';

const RESOURCE_TYPE_JIRA_HOME = 'JIRA_HOME';
const RESOURCE_TYPE_JIRA_HOME_PROJECT_REC_EXPERIMENT = 'JIRA_HOME_PROJECT_REC_EXPERIMENT';
const RESOURCE_TYPE_JIRA_HOME_ALL_FOR_YOU_EXPERIMENT = 'JIRA_HOME_ALL_FOR_YOU_EXPERIMENT';
const RESOURCE_TYPE_JIRA_HOME_ACTIONS_EXPERIMENT = 'JIRA_HOME_ACTIONS_EXPERIMENT';

const isRecommendedDataRequired = () =>
	expVal('recommended_projects_for_you_page', 'isEnabled', false) ||
	expVal('recommended_actions_on_for_you', 'isEnabled', false);

export const jiraHomeResourceWithCache: RouteResource<JiraHomeRouteResourceData | null> =
	resourceWithCondition(
		isRecommendedDataRequired,
		// recommended_projects_for_you_page or recommended_actions_on_for_you is ON
		resourceWithCondition(
			() => expVal('recommended_actions_on_for_you', 'isEnabled', false),
			// Both recommended_projects_for_you_page + recommended_actions_on_for_you are ON
			createResource<JiraHomeRouteResourceData | null>({
				type: RESOURCE_TYPE_JIRA_HOME_ALL_FOR_YOU_EXPERIMENT,
				getKey: () => 'jira-home-for-you-exp',
				getDataLoader: () =>
					import(
						/* webpackChunkName: "async-resource-jira-home-for-you-exp", jiraSpaEntry: "async-resource-jira-home-for-you-exp" */ './GetDataForYouExperimentGetData.tsx'
					),
				maxAge: Infinity,
			}),
			// Only recommended_projects_for_you_page or recommended_actions_on_for_you is ON
			createResource<JiraHomeRouteResourceData | null>({
				type: RESOURCE_TYPE_JIRA_HOME_PROJECT_REC_EXPERIMENT,
				getKey: () => 'jira-home-2',
				getDataLoader: () =>
					import(
						/* webpackChunkName: "async-resource-jira-home-with-cache-2", jiraSpaEntry: "async-resource-jira-home-2" */ './GetDataExperimentGetData.tsx'
					),
				maxAge: Infinity,
			}),
		),
		// recommended_projects_for_you_page is OFF
		resourceWithCondition(
			() => expVal('recommended_actions_on_for_you', 'isEnabled', false),
			// Only recommended_actions_on_for_you is ON
			createResource<JiraHomeRouteResourceData | null>({
				type: RESOURCE_TYPE_JIRA_HOME_ACTIONS_EXPERIMENT,
				getKey: () => 'jira-home-actions-exp',
				getDataLoader: () =>
					import(
						/* webpackChunkName: "async-resource-jira-home-actions-exp", jiraSpaEntry: "async-resource-jira-home-actions-exp" */ './GetDataActionsExperimentGetData.tsx'
					),
				maxAge: Infinity,
			}),
			// Both experiments are OFF - use old logic
			createResource<JiraHomeRouteResourceData | null>({
				type: RESOURCE_TYPE_JIRA_HOME,
				getKey: () => 'jira-home',
				getDataLoader: () =>
					import(
						/* webpackChunkName: "async-resource-jira-home-with-cache", jiraSpaEntry: "async-resource-jira-home" */ './getData.tsx'
					),
				maxAge: Infinity,
			}),
		),
	);
